module.exports = function(bootstrap) {
    bootstrap.directive('homeHealthProvider', [function() {
        return {
            restrict: 'A',
            replace: true,
            scope: { homeHealthProvider: '=' },
            template: '<span class="homeHealthProvider"><span data-button-builder data-toggle="homeHealthProvider" data-icon-classes="\'hm-icon icon-font-home OrangeYouGlad btn-icon\'" data-modal-text="\'Providers in this practice will only perform Home Visits/House Calls. Please call the practice for more details.\'" data-name="\'HOME VISIT ONLY PROVIDER\'"></span></span>'
        };
    }]);
};
